/**
 * ATTENZIONE: Mantenere allineato all'analogo file in export, Package/Geco e Package/Geco-React16
 */

export const iframeId = 'OverlaySupport';

// lista di messaggi da rigirare al client. ATTENZIONE: i messaggi devono essere allineati alla parte client.
export const messaggiServerEnum = {
  RispostaInviata: 'RispostaInviata',
  PrerispostaInviata: 'PrerispostaInviata',
  NuovoMessaggioPubblicato: 'NuovoMessaggioPubblicato',
  PraticaChiusa: 'PraticaChiusa',
  PraticaPresaInCarico: 'PraticaPresaInCarico',
  NuovoQuesito: 'NuovoQuesito',
  AssociatiFileAllegatiAllaReplica: 'AssociatiFileAllegatiAllaReplica',
  AssociatiFileAllegatiAllaPrerisposta: 'AssociatiFileAllegatiAllaPrerisposta',
  AssociatiFileAllegatiAllaRisposta: 'AssociatiFileAllegatiAllaRisposta',
};

export const messaggiServer = [
  messaggiServerEnum.RispostaInviata,
  messaggiServerEnum.PrerispostaInviata,
  messaggiServerEnum.NuovoMessaggioPubblicato,
  messaggiServerEnum.PraticaChiusa,
  messaggiServerEnum.PraticaPresaInCarico,
  messaggiServerEnum.NuovoQuesito,
  messaggiServerEnum.AssociatiFileAllegatiAllaReplica,
  messaggiServerEnum.AssociatiFileAllegatiAllaPrerisposta,
  messaggiServerEnum.AssociatiFileAllegatiAllaRisposta,
];

export const MessageType = {
  Initialize: 'servizicgn.helpdesk.frontend.initialize',
  SetUfficio: 'servizicgn.helpdesk.frontend.setUfficio',
  CreateNuovoQuesito: 'servizicgn.helpdesk.frontend.createNuovoQuesito',
  SendSignalREvent: 'servizicgn.helpdesk.frontend.sendSignalREvent',
  OverlayClosed: 'servizicgn.helpdesk.frontend.overlayClosed',
};

export function sendMessage(type, message) {
  const iframe = document.getElementById(iframeId);
  if (iframe != null && iframe.contentWindow != null) {
    iframe.contentWindow.postMessage({
      ...message,
      type,
    }, '*');
  }
}

export function sendMessageToParent(type, message) {
  const { parent } = window;
  if (parent != null) {
    parent.postMessage(
      {
        ...message,
        type,
      },
      '*',
    );
  }
}
